import React from 'react';
import { FiClock, FiMoreHorizontal } from 'react-icons/fi';
import { Link } from 'react-router-dom';
import Dropdown from 'src/app/components/Dropdown';
import useAuthorityLevel from '@/app/hooks/useAuthorityLevel';
import moment from 'moment';
import { useClient } from 'jsonapi-react';
import Swal from 'sweetalert2';
import { t } from 'i18next';
import usePermission from '@/app/hooks/usePermission';
import toast from 'react-hot-toast';
import { LiveClassCard as LCCard, LiveClassCardBody, LiveClassCardFooter, LiveClassCardHeader, LiveClassCardHeaderInner, LiveClassCardTime, LiveClassCardTitle } from '@/components/custom/live-class';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';

export default function LiveClassCard(props) {
  const { liveClass, setEditingLiveClass, setShowLiveClassForm, setCurrentLive, setWeekDays } = props;
  const client = useClient();
  const authorityLevel = useAuthorityLevel();
  const isAdmin = authorityLevel !== 'student';

  const isSame = moment(liveClass['initial-date']).format('YYYY-MM-DD') === moment(liveClass['end-date']).format('YYYY-MM-DD');
  const formattedInitialDate = moment(liveClass['initial-date']).format(isSame ? 'HH[h]mm' : 'DD/MM - HH[h]mm');
  const formattedEndDate = moment(liveClass['end-date']).format(isSame ? 'HH[h]mm' : 'DD/MM - HH[h]mm');
  const date = `${formattedInitialDate} às ${formattedEndDate}`;

  const currentDate = moment();

  const isOnSchedule = currentDate.isBetween(liveClass['initial-date'], liveClass['end-date']);

  const deleteLive = async () => {
    const { error } = await client.delete(`live_classrooms/${liveClass?.id}`);
    if (error) {
      toast.error(t('toast.errorDeleteLesson'));
    } else {
      setWeekDays(prevState => prevState.filter(item => item.id !== liveClass?.id));
      toast.success(t('toast.successDeleteLesson'));
    }
  };

  const handleDelete = () => {
    Swal.fire({
      title: t('projects.warningDeleteLesson'),
      confirmButtonText: t('button.yes'),
      showDenyButton: true,
      denyButtonText: t('button.no'),
      showCloseButton: true
    }).then(res => {
      if (res.isConfirmed) {
        deleteLive();
      }
    });
  };

  return (
    <LCCard>
      <LiveClassCardHeader>
        <LiveClassCardHeaderInner>
          <Badge
            variant={isOnSchedule ? 'success' : 'warning'}
            size="sm"
          >
            {isOnSchedule ? 'Online' : 'Offline'}
          </Badge>

          {usePermission('Editar aulas ao vivo', 'Aulas ao vivo') || usePermission('Excluir aulas ao vivo', 'Aulas ao vivo') ? (
            <Dropdown>
              <Dropdown.Toggle>
                <span className="card__icon-wrapper u-py-0">
                  <FiMoreHorizontal className="card__icon" />
                </span>
              </Dropdown.Toggle>

              <Dropdown.Content>
                {usePermission('Editar aulas ao vivo', 'Aulas ao vivo') && (
                  <Dropdown.Item
                    onClick={() => {
                      setEditingLiveClass(true);
                      setShowLiveClassForm(true);
                      setCurrentLive(liveClass);
                    }}
                  >
                    {t('button.edit')}
                  </Dropdown.Item>
                )}
                {usePermission('Excluir aulas ao vivo', 'Aulas ao vivo') && (
                  <Dropdown.Item
                    onClick={() => {
                      handleDelete();
                    }}
                  >
                    {t('button.delete')}
                  </Dropdown.Item>
                )}
              </Dropdown.Content>
            </Dropdown>
          ) : null}
        </LiveClassCardHeaderInner>

        <LiveClassCardTitle title={liveClass.title}>{liveClass.title}</LiveClassCardTitle>
      </LiveClassCardHeader>

      <LiveClassCardBody>
        <LiveClassCardTime title={date}>
          <FiClock /> {date}
        </LiveClassCardTime>
      </LiveClassCardBody>

      <LiveClassCardFooter>
        <Button
          size="xs"
          fullWidth
          asChild
          disabled={!isOnSchedule}
        >
          <Link to={String(liveClass.id)}>{t('button.access')}</Link>
        </Button>
      </LiveClassCardFooter>
    </LCCard>
  );
}
